angular.module('picmonicng').factory('AccessCodesResource', [
  '$resource',
  function ($resource) {
    return $resource(
      'api/v3/accesscodes',
      {},
      {
        get: { method: 'GET', url: '/api/v3/accesscodes/:code' },
        redeem: { method: 'POST', isArray: false },
      }
    );
  },
]);
